

























































import Vue from 'vue';
import { mapState } from 'vuex';
import KnowledgeAssociation from '@/components/knowledge/KnowledgeAssociation.vue';
import Header from '@/components/Header.vue';
import pxCard from '@/dex-shared/components/px-card.vue';
import pxButton from '@/dex-shared/components/px-button.vue';

export default Vue.extend({
  components: {
    pxCard,
    pxButton,
    KnowledgeAssociation,
    Header,
  },
  data() {
    return {
      selectedOldKnowledge: undefined,
      redefining: false,
    };
  },
  computed: {
    ...mapState({
      oldKnowledgeAssociations: (state: any) =>
        state.oldKnowledges.oldKnowledgeAssociations,
      newKnowledge: (state: any) => state.treeKnowledges.knowledges,
    }),
    sortedOldKnowledges() {
      const collator = new Intl.Collator('pt-br', {
        numeric: true,
        sensitivity: 'base',
      });
      return this.oldKnowledgeAssociations
        .concat()
        .sort((a: any, b: any) =>
          collator.compare(a.knowledge.name, b.knowledge.name),
        );
    },
  },
  async created() {
    await this.$store.dispatch('PULL_OLD_KNOWLEDGE_ASSOCIATIONS');
  },
  methods: {
    async redefine(onlyExclude: boolean) {
      this.redefining = true;
      if (this.selectedOldKnowledge) {
        if (onlyExclude) {
          await this.$store.dispatch('REDEFINE_OLD_KNOWLEDGE_ASSOCIATIONS', {
            oldKnowledgeId: this.selectedOldKnowledge.knowledge.id,
            skipInsertion: true,
          });
        } else if (this.newKnowledge.length === 1) {
          await this.$store.dispatch('REDEFINE_OLD_KNOWLEDGE_ASSOCIATIONS', {
            oldKnowledgeId: this.selectedOldKnowledge.knowledge.id,
            newLtreeKnowledgesId: this.newKnowledge[0].id,
          });
        }
        await this.$store.dispatch('PULL_OLD_KNOWLEDGE_ASSOCIATIONS');
      }
      this.redefining = false;
    },
  },
});
